import $ from 'jquery';
import 'jquery.marquee';

const bodyWidth = $('body').outerWidth();
const marqueeDOM = $('.teams-header-marquee-title');
marqueeDOM.css('width', bodyWidth);

marqueeDOM.marquee({
    duration: 20000,
    gap: 30,
    delayBeforeStart: 0,
    direction: 'left',
    duplicated: true,
    pauseOnHover: true,
    startVisible: true,
});
